import { render, staticRenderFns } from "./POIRegionEdit.vue?vue&type=template&id=4557522c"
import script from "./POIRegionEdit.js?vue&type=script&lang=js&external"
export * from "./POIRegionEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports